// 

<template>
  	<v-container fluid pa-0 ma-0 grid-list-sm>
    <v-layout row wrap>
    <v-flex>
    <v-card
      width="800"
    >
      <v-toolbar dense
        color="blue-grey darken-3"
        shaped
      >
        <v-toolbar-title>Users</v-toolbar-title>
        <v-spacer></v-spacer>
		<v-text-field v-model="filter" hide-details prepend-icon="search" single-line clearable @click:clear="onSearchClear()"></v-text-field>  
        <v-spacer></v-spacer>
        <v-btn color="blue-grey darken-4" @click.stop="onSearch()">Search</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey darken-4" @click.stop="onEditItem()">New</v-btn>
      </v-toolbar>
        <v-data-table
			:headers="headers"
			:items="filteredItems"
			item-key="id"
			:page.sync="page"
      		:items-per-page="10"
      		must-sort
      		:sort-by.sync="sortBy"
      		:sort-desc.sync="sortDesc"
			class="elevation-1"
      		hide-default-footer
		>
		    <template v-slot:item.id="{ item }">
		    	<v-chip color="blue-grey" dark x-small>{{ item.id }}</v-chip>
		    </template>
			<template v-slot:item.open="{ item }">
				<v-icon color="amber darken-2" @click.stop="onEditItem(item.id)">folder_open</v-icon>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon color="grey lighten-2" @click.stop="onPrintItem(item.id)">print</v-icon>
			</template>
      		<template slot="footer">
      			<div class="text-xs-center pt-2">
					<v-pagination color="blue-grey" v-model="page" :length="pages" :total-visible="7" @input="onPageChange"></v-pagination>
				</div>
      		</template>
    	</v-data-table>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
    </v-card>
	</v-flex>
    </v-layout>
    <UserPopup :model="item" @popup-cancelled="editCancelled()" @popup-submitted="editSubmitted()" />
    <v-snackbar v-model="snack.active" :color="snack.type"> {{ snack.text }}
      <v-btn text dark @click="snack.active = false">Ok</v-btn>
    </v-snackbar>
	</v-container>
</template>

<script>
	import UserPopup from './UserPopup'
	import { mapGetters } from 'vuex'
	export default {
		name: 'users',
		components: {
			UserPopup,
		},
		data () {
			return {
				loading: false,
				dialog: false,
				item: {},
				edit: false,
				page: 1,
				pages: 1,
				sortBy: 'id',
				sortChangeTime: null,
        		sortDesc: true,
        		filter: '',
				headers: [
					{ text: 'ID', value: 'id', align: 'right', sortable: true, },
					{ text: 'name', value: 'name', align: 'left', sortable: true, },
					{ text: 'email', value: 'email', align: 'left', sortable: true, },
					{ text: 'open', value: 'open', align: 'center', sortable: false, },
					{ text: 'action', value: 'action', align: 'center', sortable: false, },
				],
				snack: {
					active: false,
					type: 'success',
					text: 'saved',
				},
			}
		},
		computed: {
			...mapGetters({
				items: 'users/getUsers',
			}),
			filteredItems: function () {
				let self = this
				if(!self.items.length) {return []}
				if(!self.searchQuery || self.searchQuery.length < 3) {
					return self.items
				} else {
					return self.items.filter(function (item) {
						var searchRegex = new RegExp(self.searchQuery, 'i')
						return searchRegex.test(item.name)
					})
				}
			},
		},
		mounted() {
			this.fetchData ()
		},
		methods: {
			fetchData () {
				this.loading = true
				let param = {
					page: this.page,
					sortBy: this.sortBy,
					sortDesc: (this.sortDesc?'desc':'asc'),
					filter: this.filter,
				}
				let self = this
				this.$store.dispatch('users/getUsers', param)
				.then((response) => {
					//console.log(response)
                    self.page = response.data.current_page
                    self.pages = response.data.last_page
					self.loading = false
					/*console.log('Abilities:')
					console.log(ability)
					console.log(ability.can('list', 'users'))
					console.log(ability.can('show', { model: 'users', id: 1 }))
					console.log(ability.can('create', { model: 'users', team_id: 3 }))*/
				})
				.catch((error) => {
					console.log(error)
					self.loading = false
				});
			},
			onSearch () {
				this.fetchData ()
			},
			onSearchClear () {
				this.filter = ''
				this.fetchData ()
			},
			onPageChange () {
				this.fetchData ()
			},
			onPrintItem (index) {
				alert('x')
			},
			onEditItem (id = null) {
				if(id >= 0) {
					this.item = Object.assign({}, this.filteredItems.find(x => x.id === id))
				} else {
					this.item = {}
				}
				this.edit = true
			},
			editCancelled () {
				this.edit = false
        		this.snack = {active: true, type: 'warning', text: 'cancelled'}
			},
			editSubmitted() {
				this.fetchData ()
				this.edit = false
        		this.snack = {active: true, type: 'success', text: 'saved'}
			},
			onSortChange () {
				this.$nextTick(() => {
					this.fetchData ()
				})
			},
		},
		watch: {
			sortBy () {
				if(Date.now() - this.sortChangeTime > 50) setTimeout(this.onSortChange (), 50)
				this.sortChangeTime = Date.now()
			},
			sortDesc () {
				if(Date.now() - this.sortChangeTime > 50) setTimeout(this.onSortChange (), 50)
				this.sortChangeTime = Date.now()
			},
		},
	}
</script>

<style>
</style>